import type { ChannelId } from "@sunrise/backend-types-core";
import { type Nullable, atomWithStorageWithDefault } from "@sunrise/utils";

export const lastWatchedChannelIdAtom = atomWithStorageWithDefault<
  Nullable<ChannelId>
>("last-watched-channel-id", null);
